export const options = state => state.adminReducer.snapshot.options

export const snapshot = state => state.adminReducer.snapshot.snapshot

export const isLoading = state => state.adminReducer.snapshot.isLoading

export const permissions = state => state.adminReducer.snapshot.permissions
